module.exports = __webpack_public_path__ + "img/icon-seal-cate.237e4306.png";